import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ContactMessage {
  id: string;
  name: string;
  email: string;
  message: string;
}

interface ContactState {
  messages: ContactMessage[];
}

const initialState: ContactState = {
  messages: []
};

export const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    addMessage(state, action: PayloadAction<ContactMessage>) {
      state.messages.push(action.payload);
    }
  }
});

export const { addMessage } = contactSlice.actions;
export default contactSlice.reducer;
